import React from 'react';
import { useNavigate } from 'react-router-dom';
import ForbiddenImg from 'assets/img/errors/403-error-forbidden.svg';

const NotAuthorized = () => {
  const navigate = useNavigate();

  const handleGoToBack = () => {
    navigate(-1);
  }

  return (
    <div className="tw-h-screen tw-w-full tw-flex tw-items-center tw-justify-center tw-bg-gradient-to-br tw-from-gray-50 tw-to-gray-100 tw-overflow-hidden">
      <div className="tw-w-full tw-h-full tw-bg-white tw-shadow-2xl tw-overflow-hidden tw-flex tw-items-center tw-justify-center">
        <div className="tw-px-4 tw-py-6 md:tw-px-12 lg:tw-px-20 tw-flex tw-flex-col tw-items-center tw-justify-center tw-text-center tw-h-full tw-overflow-y-auto">
          {/* Error Image */}
          <div className="tw-mb-4 tw-w-full tw-max-w-sm tw-flex-shrink-0">
            <img
              src={ForbiddenImg}
              alt="403 Forbidden"
              className="tw-w-full tw-h-auto tw-object-contain"
            />
          </div>

          {/* Error Title */}
          <h1 className="tw-text-4xl md:tw-text-5xl tw-font-bold tw-text-red-600 tw-mb-1">
            403
          </h1>
          
          {/* Error Message */}
          <h2 className="tw-text-xl md:tw-text-2xl tw-font-bold tw-text-gray-800 tw-mb-3">
            Access Denied
          </h2>

          <p className="tw-text-sm md:tw-text-base tw-text-gray-600 tw-mb-6 tw-leading-relaxed tw-max-w-2xl">
            You are not authorized or do not have the necessary permissions to access this page.
          </p>

          {/* Action Buttons */}
          <div className="tw-flex tw-flex-col tw-gap-2 tw-w-full md:tw-max-w-xl tw-mb-4">
            <button
              onClick={handleGoToBack}
              className="tw-w-full tw-px-6 tw-py-2 tw-text-sm md:tw-py-3 md:tw-text-base tw-bg-gradient-to-r tw-from-blue-600 tw-to-blue-500 tw-text-white tw-font-semibold tw-rounded hover:tw-shadow-lg hover:tw-from-blue-700 hover:tw-to-blue-600 tw-transition tw-duration-200 tw-ease-in-out"
            >
              ← Go Back
            </button>

            <a
              href="mailto:portal@pebsteel.com.vn"
              className="tw-w-full tw-px-6 tw-py-2 tw-text-sm md:tw-py-3 md:tw-text-base tw-bg-gray-100 tw-text-gray-700 tw-font-semibold tw-rounded hover:tw-bg-gray-200 tw-transition tw-duration-200 tw-text-center"
            >
              📧 Contact IT Department
            </a>
          </div>

          {/* Divider */}
          <div className="tw-w-full md:tw-max-w-xl tw-h-px tw-bg-gray-200 tw-mb-4"></div>

          {/* Help Text */}
          <p className="tw-text-xs md:tw-text-sm tw-text-gray-500 tw-max-w-2xl">
            If you believe this is an error, please contact the IT department with your request details.
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotAuthorized;
